import React from 'react';
import { Phone, MapPin, Star, Clock } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  return (
    <section className="relative pt-24 md:pt-32 pb-16 md:pb-24 bg-gradient-to-br from-[#f7f5f2] to-white overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent-primary/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent-secondary/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            {/* Rating Badge */}
            <div className="inline-flex items-center space-x-2 bg-white rounded-full px-4 py-2 shadow-sm border border-gray-100">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 text-yellow-400 fill-yellow-400"
                  />
                ))}
              </div>
              <span className="text-sm font-semibold text-gray-900">4.9</span>
              <span className="text-sm text-gray-600">• 1,218 reviews</span>
            </div>

            {/* Main Headline */}
            <div>
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight">
                Envoq Salon
              </h1>
              <p className="text-2xl md:text-3xl text-accent-primary font-semibold mt-2">
                Jayanagar
              </p>
            </div>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-gray-700 max-w-xl">
              Jayanagar's most-loved beauty destination. Expert stylists, premium products, and personalized care that keeps 1200+ customers coming back.
            </p>

            {/* Quick Info */}
            <div className="flex flex-wrap gap-4 text-sm text-gray-600">
              <div className="flex items-center space-x-2">
                <Clock className="w-5 h-5 text-accent-primary" />
                <span>Open Daily 9 AM - 9 PM</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="w-5 h-5 text-accent-primary" />
                <span>1st Block, Jayanagar</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                size="lg"
                asChild
                className="bg-accent-primary hover:bg-accent-primary-dark text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <a href="tel:+919955885574">
                  <Phone className="w-5 h-5 mr-2" />
                  Call to Book Now
                </a>
              </Button>
              <Button
                size="lg"
                variant="outline"
                asChild
                className="border-2 border-accent-primary text-accent-primary hover:bg-accent-primary hover:text-white text-lg px-8 py-6 transition-all duration-300"
              >
                <a
                  href="https://maps.google.com/?cid=1419869882600592434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <MapPin className="w-5 h-5 mr-2" />
                  Get Directions
                </a>
              </Button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.pexels.com/photos/7195799/pexels-photo-7195799.jpeg?auto=compress&cs=tinysrgb&w=800"
                alt="Envoq Salon Interior"
                className="w-full h-[500px] object-cover"
              />
              {/* Overlay badge */}
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm rounded-xl p-4 shadow-lg">
                <p className="text-sm text-gray-600">Trusted by</p>
                <p className="text-3xl font-bold text-accent-primary">1,200+</p>
                <p className="text-sm text-gray-700">Happy Customers</p>
              </div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-accent-secondary rounded-2xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;